import React from "react";
import { Link } from "react-router-dom";

const styles = `
  /* ── Ticker ── */
  .ba-ticker-wrap {
    background: #1a1a2e;
    border-bottom: 2px solid #C8720A;
    overflow: hidden;
    display: flex;
    align-items: center;
    height: 36px;
  }

  .ba-ticker-label {
    background: #C8720A;
    color: #fff;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 0 18px;
    height: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    flex-shrink: 0;
    font-family: 'Segoe UI', sans-serif;
  }

  .ba-ticker-track {
    overflow: hidden;
    flex: 1;
  }

  .ba-ticker-inner {
    display: flex;
    animation: baTicker 10s linear infinite;
    white-space: nowrap;
  }

  .ba-ticker-inner:hover {
    animation-play-state: paused;
  }

  .ba-ticker-item {
    font-size: 0.78rem;
    color: rgba(255,255,255,0.85);
    padding: 0 40px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-family: 'Segoe UI', sans-serif;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s;
  }

  .ba-ticker-item:hover {
    color: #F0C040;
    text-decoration: none;
  }

  .ba-ticker-item::before {
    content: '●';
    color: #C8720A;
    font-size: 0.4rem;
    flex-shrink: 0;
  }

  @keyframes baTicker {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
`;

const tickerItems = [
  {
    label:
      "Cybercrime Alert: Scammers impersonating Indian Police target seniors abroad",
    to: "/cyber-crime-alert",
  },
  {
    label:
      "AI Agents Go Mainstream: How Autonomous Models Are Reshaping the Tech Industry in 2026",
    to: "/articles/ai-agents-mainstream-2026",
  },
  {
    label:
      "AI's Power Hunger Is Straining National Grids — Big Tech races to nuclear energy",
    to: "/articles/ai-power-hunger-strains-national-grids-2026",
  },
];

// Duplicate for seamless loop
const allTickers = [...tickerItems, ...tickerItems];

function NewsBanner() {
  return (
    <>
      <style>{styles}</style>

      <div className="ba-ticker-wrap">
        <div className="ba-ticker-label">Latest</div>
        <div className="ba-ticker-track">
          <div className="ba-ticker-inner">
            {allTickers.map((item, i) => (
              <Link key={i} to={item.to} className="ba-ticker-item">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsBanner;
